import classnames from 'classnames';
import React, { FC, useRef } from 'react';

import { FocusContainer } from '@eika/focus-container';
import { Icon, IconTypes } from '@eika/icon';

import './ConfirmationDialog.scss';

export interface ConfirmationDialogProps {
    className?: string;
    title: string;
    id: string;
    description?: string;
    footer: JSX.Element;
    show: boolean;
    icon?: IconTypes;
    blueBackground?: boolean;
    onExitFocus: () => void;
    headingLevel?: number;
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
    className,
    title,
    description,
    footer,
    show,
    icon,
    blueBackground,
    id,
    onExitFocus,
    headingLevel,
}) => {
    const dialog = useRef<HTMLElement>(null);

    return (
        <FocusContainer entry={show} onExit={onExitFocus}>
            <section
                role="alert"
                aria-labelledby={id}
                className={classnames('sgw-confirmation-dialog', className, {
                    'blue-background': blueBackground,
                    'hidden-dialog': !show,
                    'bottom-padding': icon,
                })}
                ref={dialog}
            >
                {icon && <Icon className="sgw-confirmation-dialog__icon" type={icon} />}
                <h2 aria-level={headingLevel} className="sgw-confirmation-dialog__title" id={id}>
                    {title}
                </h2>
                <p className="sgw-confirmation-dialog__description">{description}</p>
                <div className="sgw-confirmation-dialog__footer">{footer}</div>
            </section>
        </FocusContainer>
    );
};

export default ConfirmationDialog;
